import { Backend } from '@shared/datastore/core';
import { ProjectsGetResultApi } from 'api-typings/projects/projects';

declare module '../core/backend' {
  interface BackendApiFetchTypes {
    threadProjects: ProjectsGetResultApi;
  }
}

export const threadProjectsBackend: Backend<'threadProjects'> = {
  fetch: (_, projectIds) => ({
    endpoint: `projects/0.1/projects`,
    params: {
      user_details: 'true',
      user_avatar: 'true',
      support_status_details: 'true',
      projects: projectIds || [],
    },
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/thread-projects/thread-projects.backend.ts